/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AutopilotSuggestionInvite_referencedEvents = ReadonlyArray<{
    readonly title: string | null;
    readonly isAllDay: boolean | null;
    readonly startTime: {
        readonly millis: number;
    };
    readonly endTime: {
        readonly millis: number;
    };
    readonly eventKey: {
        readonly externalEventId: string;
    };
    readonly " $refType": "AutopilotSuggestionInvite_referencedEvents";
}>;
export type AutopilotSuggestionInvite_referencedEvents$data = AutopilotSuggestionInvite_referencedEvents;
export type AutopilotSuggestionInvite_referencedEvents$key = ReadonlyArray<{
    readonly " $data"?: AutopilotSuggestionInvite_referencedEvents$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AutopilotSuggestionInvite_referencedEvents">;
}>;



const node: ReaderFragment = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "plural": true
        },
        "name": "AutopilotSuggestionInvite_referencedEvents",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAllDay",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "startTime",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "endTime",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventKey",
                "kind": "LinkedField",
                "name": "eventKey",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "externalEventId",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Event",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '08ea10e66d3ecf48f4b842db8d7e930a';
export default node;
